"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
var autoComplete_1 = require("./backbone/views/autoComplete");
var nestedDropDown_1 = require("./backbone/views/nestedDropDown");
var downloadForm_1 = require("./downloadForm");
var mapDownloadForm_1 = require("./backbone/views/mapDownloadForm");
var collapsable_1 = require("./backbone/views/collapsable");
var startPageChart_1 = require("./backbone/views/startPageChart");
var underscore_1 = __importDefault(require("underscore"));
var jquery_1 = __importDefault(require("jquery"));
var chartSelectionView_1 = require("./backbone/views/chartSelectionView");
var chartSurveySource_1 = require("./backbone/views/chartSurveySource");
var municipalitySelection_1 = require("./backbone/views/municipalitySelection");
var topMunicipalities_1 = require("./backbone/views/topMunicipalities");
var chartExcelDownloads_1 = require("./backbone/views/chartExcelDownloads");
var chartSelection_1 = require("./backbone/models/chartSelection");
var bigChart_1 = require("./backbone/views/bigChart");
var comparePanel_1 = require("./backbone/views/comparePanel");
jquery_1.default(function () {
    jquery_1.default('.js-nested-drop-down').each(function () {
        new nestedDropDown_1.NestedDropDown({ el: this });
    });
    jquery_1.default('.js-auto-complete').each(function () {
        new autoComplete_1.AutoComplete({ el: this }).render();
    });
    jquery_1.default('select.js-nested').each(function () {
        nestedDropDown_1.NestedDropDown.createFor(this);
    });
    jquery_1.default('.js-download-form').each(function () {
        new downloadForm_1.DownloadForm({ el: this });
    });
    jquery_1.default('.js-map-download').each(function () {
        new mapDownloadForm_1.MapDownloadForm({ el: this });
    });
    jquery_1.default('.js-collapsable').each(function () {
        new collapsable_1.Collapsable({ el: this });
    });
    return jquery_1.default('.js-start-page-chart').each(function () {
        new startPageChart_1.StartPageChart({ el: this }).render();
    });
});
// NOTE: exists on statistics page
jquery_1.default(function () {
    if (jquery_1.default('#js-big-chart').length === 0) {
        return;
    }
    var group = jquery_1.default('#js-big-chart').data('group');
    // @ts-ignore - jQuery typing...
    var factors = jquery_1.default('.js-factors option[value]').map(function (index, e) { return e.value; });
    var selectedChart = window.selectedChart || ''; // TODO Clean this up
    if (!selectedChart) {
        var val = jquery_1.default('.js-factors').val();
        if (typeof val === 'string')
            selectedChart = val;
    }
    var factor = underscore_1.default.includes(factors, selectedChart)
        ? selectedChart
        : 'summary_evaluation';
    // const cookie         = Cookies.get('municipalities');
    // const stored         = cookie && jQuery.parseJSON(cookie) || [];
    // const municipalities = [window.municipalityName];
    var excludeSweden = jquery_1.default('#js-big-chart').data('exclude-sweden');
    var model = new chartSelection_1.ChartSelection({
        // const model = new ChartSelection({
        municipalityNames: Muni.data.municipalityNames,
        countyNames: Muni.data.countyNames,
        group: group,
        excludeSweden: excludeSweden
    });
    jquery_1.default('.js-grading-scale').each(function () {
        var scale = jquery_1.default(this);
        model.bind('change:factor', function () { return scale.toggle(model.showGradingScale()); });
    });
    new bigChart_1.BigChart({ el: jquery_1.default('#js-big-chart')[0], model: model });
    // @ts-ignore
    new comparePanel_1.ComparePanel({ el: jquery_1.default('.js-compare-panel')[0], model: model, municipality: window.municipalityName });
    jquery_1.default('.js-chart-selection').each(function () {
        new chartSelectionView_1.ChartSelectionView({ el: this, model: model });
    });
    jquery_1.default('.js-chart-survey-source').each(function () {
        new chartSurveySource_1.ChartSurveySource({ el: this, model: model });
    });
    jquery_1.default('.js-municipality-selection').each(function () {
        new municipalitySelection_1.MunicipalitySelection({ el: this, model: model });
    });
    jquery_1.default('.js-top-municipalities').each(function () {
        new topMunicipalities_1.TopMunicipalities({ el: this, model: model });
    });
    jquery_1.default('.js-chart-excel-download').each(function () {
        new chartExcelDownloads_1.ChartExcelDownload({ el: this, model: model }).render();
    });
    model.set({
        factor: factor,
        municipality: window.municipalityName || 'Sverige',
        compareTo: []
    });
    return jquery_1.default(document).on('click', '[data-factor]', function (e) {
        e.preventDefault();
        factor = jquery_1.default(this).data('factor');
        return model.set('factor', factor);
    });
});
